import type { ReactNode } from 'react';
import { Modal, Button } from './ui';

// --------------------------------------------------------------------
// Impressum
//
// PLATZHALTER — vor Live-Gang vom Vereinsvorstand und ggf. einem
// Anwalt/Notar prüfen lassen. Pflichtangaben für Vereine in Österreich
// (§ 5 ECG, § 25 MedienG, § 14 UGB):
//
//   • Vollständiger Vereinsname laut Statuten
//   • ZVR-Zahl (Zentrales Vereinsregister)
//   • Anschrift (Sitz)
//   • Vertretungsberechtigte Organe (Vorstand)
//   • Gegenstand / Zweck
//   • Kontakt: Telefon, E-Mail
//   • Aufsichtsbehörde (Vereinsbehörde / BH)
//   • Bei wirtschaftlicher Tätigkeit: UID, Kammer, Gewerbeordnung
// --------------------------------------------------------------------
export function ImpressumModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Impressum"
      footer={<Button variant="primary" onClick={onClose}>Schließen</Button>}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14, fontSize: 14, lineHeight: 1.55 }}>
        <Block title="Verein">
          <strong>Union Sportverein Gaspoltshofen (Union DSG Gaspoltshofen)</strong><br />
          Vereinssitz: 4673 Gaspoltshofen, Oberösterreich<br />
          ZVR-Zahl: <em>[ZVR einsetzen]</em>
        </Block>
        <Block title="Vertretungsberechtigte Organe">
          Obmann: <em>[Name einsetzen]</em><br />
          Kassier: <em>[Name einsetzen]</em><br />
          Schriftführer: <em>[Name einsetzen]</em>
        </Block>
        <Block title="Kontakt">
          E-Mail: <span className="t-mono">office@union-gaspoltshofen.at</span><br />
          Telefon: <em>[Telefonnummer einsetzen]</em>
        </Block>
        <Block title="Zweck">
          Ausübung und Förderung des Amateursports in den Sektionen Fußball, Tennis, Tischtennis,
          Turnen, Schi, Schilanglauf und Stockschützen.
        </Block>
        <Block title="Aufsichtsbehörde">
          Bezirkshauptmannschaft Grieskirchen — Vereinsbehörde
        </Block>
        <Block title="Hinweis">
          <em style={{ color: 'var(--text-tertiary)' }}>
            Diese Angaben sind Platzhalter. Vor Inbetriebnahme bitte vom Vereinsvorstand
            (Obmann/Kassier) finalisieren und ggf. juristisch prüfen lassen.
          </em>
        </Block>
      </div>
    </Modal>
  );
}

// --------------------------------------------------------------------
// Datenschutzerklärung
//
// PLATZHALTER — DSGVO Art. 13/14. Die App selbst ist intern und nicht
// öffentlich, dennoch müssen alle protokollierten Verarbeitungen für
// die Mitglieder transparent dokumentiert sein.
// --------------------------------------------------------------------
export function DatenschutzModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Datenschutzerklärung"
      size="lg"
      footer={<Button variant="primary" onClick={onClose}>Schließen</Button>}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14, fontSize: 14, lineHeight: 1.55 }}>
        <Block title="Verantwortlicher">
          Union DSG Gaspoltshofen (siehe Impressum). Anfragen an{' '}
          <span className="t-mono">datenschutz@union-gaspoltshofen.at</span>.
        </Block>
        <Block title="Welche Daten verarbeiten wir?">
          Stammdaten (Name, Geburtsdatum, Geschlecht, Anschrift, Kontaktdaten), Vereinsdaten
          (Mitgliedsnummer, Funktion, Sektionszugehörigkeit, Ein-/Austritt, Mitgliedsart)
          und protokollierte Ereignisse (Aktivitätsprotokoll mit IP-Adresse und Zeitstempel).
          <br /><br />
          <strong>Bankdaten werden nicht verarbeitet.</strong> Der Zahlungsverkehr läuft
          außerhalb dieser Anwendung.
        </Block>
        <Block title="Rechtsgrundlage">
          Mitgliedschaftsvertrag (Art. 6 Abs. 1 lit. b DSGVO), rechtliche Verpflichtung
          (Aufbewahrung von Finanzdaten gem. BAO, Art. 6 Abs. 1 lit. c DSGVO) sowie
          berechtigtes Interesse an Vereinsverwaltung (Art. 6 Abs. 1 lit. f DSGVO).
        </Block>
        <Block title="Wo werden die Daten gespeichert?">
          Auf Servern des Anbieters Cloudflare innerhalb der Europäischen Union
          (Cloudflare D1, Jurisdiction <span className="t-mono">eu</span>). Die Übertragung
          erfolgt ausschließlich verschlüsselt (HTTPS), Passwörter werden nur als
          bcrypt-Hash gespeichert.
        </Block>
        <Block title="Wer hat Zugriff?">
          Nur autorisierte Vereinsfunktionäre mit individuellem Login. Rollen:<br />
          • <strong>Admin</strong> (Obmann, Kassier): alle Sektionen, alle Daten<br />
          • <strong>Sektionsleiter</strong>: nur die zugewiesenen Sektionen<br />
          • <strong>Stellvertreter</strong>: nur die zugewiesenen Sektionen, kein endgültiges Löschen<br />
          • <strong>Read-Only</strong> (Rechnungsprüfer): Lesezugriff auf alle Sektionen
        </Block>
        <Block title="Aufbewahrung">
          Stammdaten werden gelöscht/anonymisiert beim endgültigen Austritt. Beitrags-
          und Buchungsdaten werden gemäß § 132 BAO 7 Jahre aufbewahrt.
        </Block>
        <Block title="Deine Rechte">
          Du hast Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17),
          Einschränkung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21).
          Bei Verstößen Beschwerderecht bei der Datenschutzbehörde (<span className="t-mono">dsb.gv.at</span>).
        </Block>
        <Block title="Auskunft anfordern">
          Pro Mitglied steht ein JSON- und ein PDF-Datenexport zur Verfügung. Wende dich
          an den Obmann oder Kassier.
        </Block>
        <Block title="Cookies / Tracking">
          Es werden ausschließlich technisch notwendige Session-Cookies verwendet (HttpOnly).
          Kein Analytics, kein Tracking, kein Cookie-Banner erforderlich.
        </Block>
        <Block title="Auftragsverarbeiter">
          Cloudflare, Inc. (Hosting, DSGVO-konformer Vertrag abgeschlossen).
        </Block>
        <Block title="Hinweis">
          <em style={{ color: 'var(--text-tertiary)' }}>
            Diese Erklärung ist ein Platzhalter-Text auf Basis des aktuellen technischen Stands.
            Vor Inbetriebnahme bitte vom Vereinsvorstand und ggf. einem Datenschutzbeauftragten
            finalisieren.
          </em>
        </Block>
      </div>
    </Modal>
  );
}

function Block({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div>
      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 4 }}>{title}</div>
      <div style={{ color: 'var(--text-secondary)' }}>{children}</div>
    </div>
  );
}
